import modalFormMixin from '../mixins/modal-form.mixin';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ListadoItem from '../components/ListadoItem.vue';

export default {
  mixins: [modalFormMixin, layoutMixin, apiConsumerMixin],
  components: {
    ListadoItem,
  },
  computed: {
    listado() {
      return [
        { nombre: 'Código', valor: this.form.codigo },
        { nombre: 'Nombre Programa', valor: this.form.programaNombre },
        {
          nombre: 'Área / Tipo',
          valor: `${this.form.areaUniversidad?.nombre} / ${this.form.categoriaUniversidad?.nombre}`,
        },
        {
          nombre: 'Gestión / Versión / Grupo',
          valor: `${this.form.gestion} / ${this.form.version} / ${this.form.grupo || '-'}`,
        },
        { nombre: 'Resol. Aprob. Univ.', valor: this.form.resolucionAprobacionUniversidad },
        { nombre: 'Sede Universidad', valor: this.form.sedeUniversidad?.nombre },
        { nombre: 'Estado', valor: this.form.estado?.toUpperCase() },
        { nombre: 'Plan de Pago', valor: this.form.planPagoUniversidad?.nombre || 'No asignado' },
      ];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        codigo: null,
        programaNombre: null,
        gestion: null,
        resolucionAprobacionUniversidad: null,
        version: null,
        grupo: null,
        areaUniversidadId: null,
        areaUniversidad: null,
        fechaInicio: null,
        fechaFin: null,
        categoriaUniversidadId: null,
        categoriaUniversidad: null,
        fechaInscripcion: null,
        esNuevaVersion: null,
        sedeUniversidadId: null,
        sedeUniversidad: null,
        costosProgramaValidado: null,
        estado: null,
        programas: [],
        planPagoUniversidadId: null,
        planPagoUniversidad: null,
        ceubArchivoId: null,
        ceubSubidoPorId: null,
        ceubSubidoPorNombre: null,
        horasAcademicasCeub: null,
        numeroCreditosCeub: null,
        fechaEmisionCeub: null,
        gradoAcademicoCeub: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        programaNombre: data.programaNombre,
        gestion: data.gestion,
        resolucionAprobacionUniversidad: data.resolucionAprobacionUniversidad,
        version: data.version,
        grupo: data.grupo,
        areaUniversidadId: data.areaUniversidadId,
        areaUniversidad: data.areaUniversidad,
        fechaInicio: data.fechaInicio,
        fechaFin: data.fechaFin,
        categoriaUniversidadId: data.categoriaUniversidadId,
        categoriaUniversidad: data.categoriaUniversidad,
        fechaInscripcion: data.fechaInscripcion,
        esNuevaVersion: data.esNuevaVersion,
        sedeUniversidadId: data.sedeUniversidadId,
        sedeUniversidad: data.sedeUniversidad,
        costosProgramaValidado: data.costosProgramaValidado,
        estado: data.estado,
        programas: data.programas,
        planPagoUniversidadId: data.planPagoUniversidadId,
        planPagoUniversidad: data.planPagoUniversidad,
        ceubArchivoId: data.ceubArchivoId,
        ceubSubidoPorId: data.ceubSubidoPorId,
        ceubSubidoPorNombre: data.ceubSubidoPorNombre,
        horasAcademicasCeub: data.horasAcademicasCeub,
        numeroCreditosCeub: data.numeroCreditosCeub,
        fechaEmisionCeub: data.fechaEmisionCeub,
        gradoAcademicoCeub: data.gradoAcademicoCeub,
      };
    },
  },
};
